import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import bgImg from '../assets/images/bg-guide01.png';
import titleImg from '../assets/images/02register-title.png';
import confirmTextImg from '../assets/images/02register-confirm-text.png';
import cancelBtnImg from '../assets/images/02register-cancle-btn.png';
import okBtnImg from '../assets/images/02register-ok-btn.png';
import input1Img from '../assets/images/02register-input1.png';
import input2Img from '../assets/images/02register-input2.png';
import input3Img from '../assets/images/02register-input3.png';
import prevBtnImg from '../assets/images/02register-prev-btn.png';
import touchTxtImg from '../assets/images/02register-touch-txt.png';
import rememberImg from '../assets/images/02register-remeber.png';
import avatarPopImg from '../assets/images/02register-avatar-pop.png';
import avatarSelectedImg from '../assets/images/02register-avatar-selected.png';
import confirmBtnImg from '../assets/images/05tale-confirm-btn.png';
import contractConfirmBtnImg from '../assets/images/03contract-confirm-btn.png';
import { db } from '../firebase';
import { addUserToTimeBasedCollection } from '../utils/firebaseUtils';
import BluePopup from '../components/BluePopup';
import { saveAvatarRegistrationTime, updateBackgroundSelection, incrementRegisteredUsers } from '../utils/funnelDataUtils';

import { withUrlValidation } from '../components/withUrlValidation';
import { useSessionNavigation } from '../hooks/useSessionNavigation';
import { soundManager } from '../utils/soundUtils';
import FirebaseErrorPopup from '../components/FirebaseErrorPopup';
import { useFirebaseError } from '../hooks/useFirebaseError';

const FadeInBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 100dvw;
  height: 100dvh;
  min-height: 100dvh;
  background: url(${bgImg}) center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 1.5s ease;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: ${({ visible }) => 1 - visible};
    transition: opacity 1.5s ease;
    z-index: -1;
  }
`;

const Title = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 85dvw;
  max-width: 90dvw;
  margin-top: 5dvh;
  margin-bottom: 4dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 1.5s ease;
`;

const FormContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 85dvw;
  max-width: 83dvw;
  margin-top: 5dvh;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 1.5s ease;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 1dvh;
  align-items: flex-start; // ← 이 부분 추가
`;



const BlurOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  pointer-events: ${({ visible }) => visible ? 'auto' : 'none'};
`;

const Input = styled.input`
  width: 100%;
  height: 7dvh;
  background: rgba(34, 48, 74, 1);
  border: 0px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.5dvh;
  color: white;
  font-family: 'Noto Sans KR', 'Nanum Gothic', 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif;
  font-size: 2.5dvh;
  padding: 0 2dvh;
  outline: none;
  transition: border-color 0.3s ease;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
  
  &:focus {
    border-color: rgba(255, 255, 255, 0.8);
  }
`;

const InputLabelImg1 = styled.img`
  height: 2.7dvh;
  width: auto;
  margin-bottom: 2.5dvw;
  padding-left: 2.5dvw;
  display: block;
  object-fit: contain;
`;

const InputLabelImg2 = styled.img`
  height: 5dvh;
  width: auto;
  padding-left: 0.5dvw;
  display: block;
  object-fit: contain;
`;

const InputLabelImg3 = styled.img`
  height: 5dvh;
  width: auto;
  padding-left: 0.5dvw;
  display: block;
  object-fit: contain;
`;

const ConfirmBackgroundButton = styled.img`
  width: 50dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`;



const ConfirmText = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: boolean; isFadingOut: boolean }>`
  width: 75dvw;
  margin-top: 15dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : (visible ? 1 : 0)};
  transition: opacity 0.8s ease;
`;

const ConfirmButton = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: boolean; isFadingOut: boolean }>`
  width: 85dvw;
  margin-top: 10dvh;
  cursor: ${({ visible, isFadingOut }) => (visible && !isFadingOut) ? 'pointer' : 'default'};
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : (visible ? 1 : 0)};
  transition: opacity 0.8s ease;
  pointer-events: ${({ visible, isFadingOut }) => (visible && !isFadingOut) ? 'auto' : 'none'};
  
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`;

const ButtonContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: boolean; isFadingOut: boolean }>`
  display: flex;
  gap: 0.5dvw;
  margin-top: 7dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : (visible ? 1 : 0)};
  transition: opacity 0.8s ease;
`;

const CancelButton = styled.img.withConfig({
  shouldForwardProp: (prop) => !['isFadingOut'].includes(prop)
})<{ isFadingOut: boolean }>`
  width: 42dvw;
  cursor: pointer;
  opacity: ${({ isFadingOut }) => isFadingOut ? 0 : 1};
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`;

const OkButton = styled.img.withConfig({
  shouldForwardProp: (prop) => !['isFadingOut'].includes(prop)
})<{ isFadingOut: boolean }>`
  width: 42dvw;
  cursor: pointer;
  opacity: ${({ isFadingOut }) => isFadingOut ? 0 : 1};
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`;

const AvatarPopImage = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  width: 93dvw;
  height: auto;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: opacity 1s ease;
  pointer-events: ${({ visible }) => visible ? 'auto' : 'none'};
`;

const AvatarPopupContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: opacity 1s ease;
  pointer-events: ${({ visible }) => visible ? 'auto' : 'none'};
`;

const BackgroundOptionText = styled.div.withConfig({
  shouldForwardProp: (prop) => !['$selected', '$visible'].includes(prop)
})<{ $selected: boolean; $visible: boolean }>`
  position: absolute;
  color: ${({ $selected }) => $selected ? '#4FFFFF' : '#FFFFFF'};
  font-family: 'MapoDPP', sans-serif;
  font-size: 4.2dvw;
  cursor: ${({ $visible }) => $visible ? 'pointer' : 'default'};
  transition: all 0.3s ease;
  pointer-events: ${({ $visible }) => $visible ? 'auto' : 'none'};
  opacity: ${({ $visible }) => $visible ? 1 : 0};
  
  &:hover {
    color: ${({ $visible }) => $visible ? '#4FFFFF' : '#FFFFFF'};
  }
  
  ${({ $selected }) => $selected && `
    &::after {
      content: '◀';
      color: #4FFFFF;
      margin-left: 1dvw;
      font-size: 4.2dvw;
    }
  `}
`;

const AvatarSelectedImage = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  width: 93dvw;
  height: auto;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: opacity 1s ease;
`;

// 배후성 데이터
const allBackgrounds = [
  { name: "은밀한 모략가", cardStage: 4 },
  { name: "구원의 마왕", cardStage: 5 },
  { name: "심연의 흑염룡", cardStage: 6 },
  { name: "올림푸스", cardStage: 3 },
  { name: "해상전신", cardStage: 3 },
  { name: "강철의 주인", cardStage: 3 },
  { name: "악마같은 불의 심판자", cardStage: 3 },
  { name: "가장 어두운 봄의 여왕", cardStage: 3 },
  { name: "무저갱의 지배자", cardStage: 3 },
  { name: "디펜스 마스터", cardStage: 3 },
  { name: "구암신의", cardStage: 3 },
  { name: "긴고아의 죄수", cardStage: 3 },
  { name: "버려진 미로의 연인", cardStage: 2 },
  { name: "술과 황홀경의 신", cardStage: 2 },
  { name: "하늘의 서기관", cardStage: 2 },
  { name: "고려제일검", cardStage: 2 },
  { name: "부유한 밤의 아버지", cardStage: 2 },
  { name: "매금지존", cardStage: 2 },
  { name: "오공원 두꺼비", cardStage: 2 },
  { name: "시조의 어머니", cardStage: 2 },
  { name: "이천일류의 달인", cardStage: 2 },
  { name: "12월 25일의 주인", cardStage: 2 },
  { name: "절름발이 사기꾼", cardStage: 1 },
  { name: "여덟 머리의 군주", cardStage: 1 },
  { name: "잡배의 군주", cardStage: 1 },
  { name: "넉살 좋은 잡담꾼", cardStage: 1 },
  { name: "늙은 시계추의 관리자", cardStage: 1 },
  { name: "저주받은 검투사", cardStage: 1 },
  { name: "장막 뒤의 그림자", cardStage: 1 },
  { name: "외눈 미륵", cardStage: 1 },
  { name: "조선제일술사", cardStage: 1 },
  { name: "헌천홍도경문위무대왕", cardStage: 1 },
  { name: "양다리 전문가", cardStage: 1 },
  { name: "국정농단의 달인", cardStage: 1 }
];

// cardStage별 확률 설정
const stageProbabilities = {
  4: 0.01, // 1%
  5: 0.01, // 1%
  6: 0.01, // 1%
  3: 0.0133, // 1.33%
  2: 0.033, // 3.3%
  1: 0.0423 // 4.23%
};

// 확률 기반으로 배후성 선택하는 함수
const selectBackgroundsByProbability = (): string[] => {
  let selectedBackgrounds: string[] = [];
  
  // 최소 1개는 선택될 때까지 확률을 다시 적용
  while (selectedBackgrounds.length === 0) {
    selectedBackgrounds = [];
    
    // 각 배후성에 대해 확률 계산하여 선택
    allBackgrounds.forEach(background => {
      const probability = stageProbabilities[background.cardStage as keyof typeof stageProbabilities];
      if (Math.random() < probability) {
        selectedBackgrounds.push(background.name);
      }
    });
  }
  
  // 정확히 4개가 선택되도록 조정
  if (selectedBackgrounds.length < 4) {
    // 부족한 만큼 cardStage 1에서 추가 선택
    const stage1Backgrounds = allBackgrounds.filter(bg => bg.cardStage === 1);
    const needed = 4 - selectedBackgrounds.length;
    const availableStage1 = stage1Backgrounds.filter(bg => !selectedBackgrounds.includes(bg.name));
    
    for (let i = 0; i < needed && i < availableStage1.length; i++) {
      const randomIndex = Math.floor(Math.random() * availableStage1.length);
      selectedBackgrounds.push(availableStage1[randomIndex].name);
      availableStage1.splice(randomIndex, 1); // 중복 방지
    }
  } else if (selectedBackgrounds.length > 4) {
    // 4개 초과시 4개로 제한
    selectedBackgrounds.splice(4);
  }
  
  // 선택된 배후성들을 랜덤하게 섞기 (순서 무작위화)
  for (let i = selectedBackgrounds.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [selectedBackgrounds[i], selectedBackgrounds[j]] = [selectedBackgrounds[j], selectedBackgrounds[i]];
  }
  
  return selectedBackgrounds;
};

const RegisterPage = () => {
  const [bgVisible, setBgVisible] = useState(0);
  const [titleVisible, setTitleVisible] = useState(0);
  const [formVisible, setFormVisible] = useState(0);
  const [isFadingOut] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showAvatarPopup, setShowAvatarPopup] = useState(false);
  const [avatarPopupVisible, setAvatarPopupVisible] = useState(false);
  const [avatarOptionsVisible, setAvatarOptionsVisible] = useState(false);
  const [showAvatarSelectedPopup, setShowAvatarSelectedPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [avatarNumber, setAvatarNumber] = useState<string | null>(null);
  const [showSuccessImage, setShowSuccessImage] = useState(false);
  const [successPopupClosing, setSuccessPopupClosing] = useState(false);
  const [selectedBackground, setSelectedBackground] = useState<string>('');
  const [backgroundOptions, setBackgroundOptions] = useState<string[]>([]);
  const [showBackgroundField, setShowBackgroundField] = useState(false);
  const [isInTransition, setIsInTransition] = useState(false);
  const [avatarPopupImageLoaded, setAvatarPopupImageLoaded] = useState(false);
  const [avatarSelectedImageLoaded, setAvatarSelectedImageLoaded] = useState(false);
  
  const [nickname, setNickname] = useState('');
  const [age, setAge] = useState('');
  const { navigateWithSession } = useSessionNavigation();
  
  // Firebase 에러 핸들링 훅
  const { errorState, handleFirebaseError, hideError } = useFirebaseError();

  useEffect(() => {
    
    // 팝업 이미지들 미리 로드
    const preloadImages = () => {
      const imagesToPreload = [avatarPopImg, avatarSelectedImg];
      imagesToPreload.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    };
    preloadImages();
    
    const bgTimer = setTimeout(() => setBgVisible(1), 100);
    // 타이틀 이미지는 즉시 표시
    setTitleVisible(1);
    const formTimer = setTimeout(() => setFormVisible(1), 700);
    
    return () => {
      clearTimeout(bgTimer);
      clearTimeout(formTimer);
    };
  }, []);

  // 이름, 나이, 배후성이 모두 입력되었는지 확인
  useEffect(() => {
    if (nickname.trim() && age.trim() && !showAvatarPopup && !isInTransition) {
      // 배후성 필드가 표시되지 않은 경우 (초기 상태)
      if (!showBackgroundField) {
        setShowConfirm(true);
      } 
      // 배후성 필드가 표시된 경우 (최종 등록 단계)
      else if (showBackgroundField && selectedBackground) {
        setShowConfirm(true);
      } else {
        setShowConfirm(false);
      }
    } else {
      setShowConfirm(false);
    }
  }, [nickname, age, showAvatarPopup, isInTransition, showBackgroundField, selectedBackground]);

  useEffect(() => {
    if (showSuccessPopup) {
      setShowSuccessImage(false);
      const timer = setTimeout(() => setShowSuccessImage(true), 300);
      return () => clearTimeout(timer);
    } else {
      setShowSuccessImage(false);
    }
  }, [showSuccessPopup]);

  // 성공 팝업 닫기 및 다음 페이지 이동
  const handleSuccessPopupClose = () => {
    soundManager.playButtonClick();
    setShowSuccessImage(false);
    setTimeout(() => {
      setSuccessPopupClosing(true);
    }, 400); // 이미지 페이드아웃 후 팝업 닫힘
  };
  // 성공 팝업 애니메이션 끝나면 이동
  useEffect(() => {
    if (successPopupClosing && showSuccessPopup) {
      // BluePopup 애니메이션 시간(텍스트 0.4s + 배경 0.8s = 1.2s)
      const timer = setTimeout(() => {
        setShowSuccessPopup(false);
        setSuccessPopupClosing(false);
        // 로컬스토리지에 저장된 사용자 데이터는 이미 JSON 구조로 저장되어 있음
        navigateWithSession('/contract');
      }, 1200);
      return () => clearTimeout(timer);
    }
  }, [successPopupClosing, showSuccessPopup, navigateWithSession, nickname, avatarNumber]);

  const handleCancel = () => {
    soundManager.playButtonClick();
    setShowCancelPopup(true);
  };

  const handleCancelPopupClose = () => {
    soundManager.playButtonClick();
    setShowCancelPopup(false);
  };

  const handleCancelPopupConfirm = () => {
    soundManager.playButtonClick();
    window.location.reload();
  };

  const handleConfirm = async () => {
    soundManager.playButtonClick();
    // 배후성 필드가 표시된 후의 최종 등록인지 확인
    if (showBackgroundField) {
      // 최종 등록 - 파이어베이스에 저장
      if (!nickname.trim()) {
        alert('화신 이름을 입력해주세요.');
        return;
      }
      if (nickname.length > 10) {
        alert('이름은 10자 이하여야 합니다.');
        return;
      }
      if (!selectedBackground) {
        alert('배후성을 선택해주세요.');
        return;
      }

      // 화신번호 생성 (00~99)
      const randomNumber = Math.floor(Math.random() * 100);
      const avatarNumStr = randomNumber.toString().padStart(2, '0');

      try {
        await addUserToTimeBasedCollection({
          nickname,
          age,
          background: selectedBackground,
          avatarNumber: avatarNumStr,
          coinCount: 0, // 보유코인수 초기값
          zoneClearStatus: {
            zone1: '아직안품',
            zone2: '아직안품',
            zone3: '아직안품',
            zone4: '아직안품',
            zone5: '아직안품',
            zone6: '아직안품'
          }
        });
        
        // 로컬스토리지에 JSON 구조로 사용자 데이터 저장
        const userDataToStore = {
          nickname: nickname.trim(),
          avatarNumber: avatarNumStr,
          age: age,
          background: selectedBackground,
          coinCount: 0,
          zoneClearStatus: {
            zone1: '아직안품',
            zone2: '아직안품',
            zone3: '아직안품',
            zone4: '아직안품',
            zone5: '아직안품',
            zone6: '아직안품'
          },
          createdAt: new Date().toISOString()
        };
        
        // 로그인 상태 설정
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('currentUser', JSON.stringify(userDataToStore));
        localStorage.setItem('userRegistrationTime', Date.now().toString());
        
        // 화신 등록 시간을 로컬 스토리지에 저장 (체험 시간 계산용)
        const registrationTime = new Date();
        saveAvatarRegistrationTime(registrationTime);
        
        // 배후성 선택 횟수 추적
        updateBackgroundSelection(selectedBackground);
        
        // 등록한 유저 수 증가 (체험 중단 포인트 및 완료율 추적)
        incrementRegisteredUsers();
        
        setAvatarNumber(avatarNumStr);
        setShowSuccessPopup(true);
      } catch (e) {
        console.error('사용자 등록 실패:', e);
        // Firebase 에러 팝업 표시
        handleFirebaseError(e, '사용자 등록 중 오류가 발생했습니다.');
      }
    } else {
      // 아바타 팝업 표시
      setShowAvatarPopup(true);
    }
  };

  // 배후성 옵션 생성
  useEffect(() => {
    if (showAvatarPopup) {
      // 새로운 선택지 생성 - 확률 기반으로 선택
      const selectedBackgrounds = selectBackgroundsByProbability();
      
      // 5번은 "선택하지 않겠습니다" 고정
      const finalOptions = [...selectedBackgrounds, "선택하지 않겠습니다."];
      
      setBackgroundOptions(finalOptions);
      setSelectedBackground('');
    }
  }, [showAvatarPopup]);

  // 아바타 팝업 표시 시 visible 상태도 함께 설정
  useEffect(() => {
    if (showAvatarPopup) {
      setAvatarPopupVisible(true);
      setAvatarPopupImageLoaded(false); // 이미지 로딩 상태 초기화
      // 팝업 이미지가 완전히 로드된 후 옵션들을 표시
      setTimeout(() => {
        setAvatarOptionsVisible(true);
      }, 500); // 팝업 이미지 페이드인 완료 후 옵션들 표시
    } else {
      setAvatarOptionsVisible(false);
      setAvatarPopupImageLoaded(false);
    }
  }, [showAvatarPopup]);

  // 디버깅용 useEffect
  useEffect(() => {
  }, [avatarOptionsVisible, avatarPopupImageLoaded, selectedBackground, showAvatarPopup, showBackgroundField, showConfirm, isInTransition]);

  const handleBackgroundSelect = (background: string) => {
    soundManager.playButtonClick();
    // 5번 "선택하지 않겠습니다."를 선택한 경우 "없음"으로 저장
    if (background === "선택하지 않겠습니다.") {
      setSelectedBackground("없음");
    } else {
      setSelectedBackground(background);
    }
  };

  const handleBackgroundConfirm = () => {
    soundManager.playButtonClick();
    
    // 전환 상태 시작
    setIsInTransition(true);
    
    // 먼저 옵션들을 숨김
    setAvatarOptionsVisible(false);
    
    // AvatarPopup 페이드아웃
    setAvatarPopupVisible(false);
    
    // 페이드아웃 애니메이션 완료 후 팝업 숨김
    setTimeout(() => {
      setShowAvatarPopup(false);
      
      // 잠시 후 AvatarSelected 팝업 페이드인
      setTimeout(() => {
        setShowAvatarSelectedPopup(true);
        setAvatarSelectedImageLoaded(false); // 선택 완료 이미지 로딩 상태 초기화
        
        // 2초 후 AvatarSelected 팝업 페이드아웃
        setTimeout(() => {
          setShowAvatarSelectedPopup(false);
          
          // 팝업이 완전히 사라진 후 배후성 필드 표시
          setTimeout(() => {
            setShowBackgroundField(true);
            setIsInTransition(false);
          }, 500);
        }, 2000);
      }, 300);
    }, 1000);
  };



  return (
    <FadeInBackground visible={bgVisible} isFadingOut={isFadingOut}>
      <Title src={titleImg} alt="화신 정보 등록" visible={titleVisible} isFadingOut={isFadingOut} />
      
      <FormContainer visible={formVisible} isFadingOut={isFadingOut}>
        <InputGroup>
          <InputLabelImg1 src={input1Img} alt="화신 닉네임" />
          <Input
            type="text"
            placeholder="이름을 입력하세요."
            value={nickname}
            onChange={(e) => {
              const value = e.target.value;
              // 천지인 키보드 호환성을 위한 개선된 정규식
              // 조합 중인 문자와 모든 한글 모음, 자음을 포함
              const allowedPattern = /^[가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9\s\u3131-\u318E\u1100-\u11FF\uAC00-\uD7AF]*$/;
              
              // 10자 제한과 허용된 문자만 입력 가능하도록 제한
              if (value.length <= 10) {
                // 천지인 키보드의 조합 중인 문자를 포함한 모든 한글 입력 허용
                if (allowedPattern.test(value) || value === '') {
                  setNickname(value);
                }
              }
            }}
            maxLength={10}
            // 천지인 키보드 호환성을 위한 추가 속성
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
          />
        </InputGroup>
        
        <InputGroup>
          <InputLabelImg2 src={input2Img} alt="나이" />
          <Input
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="나이를 입력하세요."
            value={age}
            onChange={(e) => {
              const value = e.target.value;
              // 숫자만 허용하고 4자리까지만
              if (value === '' || (/^[0-9]+$/.test(value) && value.length <= 4)) {
                setAge(value);
              }
            }}
            onKeyDown={(e) => {
              // 천지인 키보드 호환성을 위해 onKeyDown 사용
              // 숫자, 백스페이스, 삭제, 탭, 엔터만 허용
              const allowedKeys = [
                'Backspace', 'Delete', 'Tab', 'Enter', 'Escape',
                'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                'Home', 'End'
              ];
              
              if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
            min="1"
            max="9999"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
          />
        </InputGroup>

        {showBackgroundField && (
          <InputGroup>
            <InputLabelImg3 src={input3Img} alt="배후성" />
            <Input
              type="text"
              placeholder="배후성"
              value={selectedBackground}
              readOnly
              style={{ backgroundColor: 'rgba(34, 48, 74, 0.7)', color: 'rgba(255, 255, 255, 0.8)' }}
            />
          </InputGroup>
        )}
      </FormContainer>

      {/* 배후성 필드가 표시된 후 나타나는 확인 텍스트와 버튼들 */}
      {showBackgroundField && (
        <>
          <ConfirmText 
            src={confirmTextImg} 
            alt="등록 확인" 
            visible={showConfirm} 
            isFadingOut={isFadingOut}
          />      
          <ButtonContainer visible={showConfirm} isFadingOut={isFadingOut}>
            <CancelButton 
              src={cancelBtnImg} 
              alt="취소" 
              isFadingOut={isFadingOut}
              onClick={handleCancel}
            />
            <OkButton 
              src={okBtnImg} 
              alt="네" 
              isFadingOut={isFadingOut}
              onClick={handleConfirm}
            />
          </ButtonContainer>
        </>
      )}

      {/* 이름, 나이만 입력했을 때 나타나는 확인 버튼 */}
      {!showBackgroundField && (
        <ConfirmButton 
          src={confirmBtnImg} 
          alt="확인" 
          visible={showConfirm} 
          isFadingOut={isFadingOut}
          onClick={handleConfirm}
        />
      )}

      {/* 취소 팝업 오버레이 */}
      {showCancelPopup && (
        <BlurOverlay visible={true} style={{ zIndex: 2000 }} />
      )}
      {/* 취소 팝업 */}
      {showCancelPopup && (
        <>
          <div style={{ position: 'fixed', top: '45%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2001 }}>
            <BluePopup>
              <span style={{ fontSize: '1.5rem', display: 'block' }}>취소하시겠습니까?</span>
              <div style={{height: '0.3rem'}} />
              <span style={{ fontSize: '1rem', display: 'block', marginTop: '0.5em' }}>작성하신 정보가 초기화됩니다.</span>
            </BluePopup>
          </div>
          <div style={{ position: 'fixed', top: '62%', left: '50%', transform: 'translate(-50%, 0)', zIndex: 2002, display: 'flex', justifyContent: 'center', gap: '0.5dvw', width: '80vw' }}>
            <img
              src={prevBtnImg}
              alt="이전"
              style={{ width: '40dvw', maxWidth: '40dvw', cursor: 'pointer' }}
              onClick={handleCancelPopupClose}
            />
            <img
              src={okBtnImg}
              alt="네"
              style={{ width: '40dvw', maxWidth: '45dvw', cursor: 'pointer' }}
              onClick={handleCancelPopupConfirm}
            />
          </div>
        </>
      )}

      {/* 아바타 팝업 */}
      {showAvatarPopup && (
        <BlurOverlay visible={avatarPopupVisible} style={{ zIndex: 2500 }} />
      )}
      {showAvatarPopup && (
        <div style={{ position: 'fixed', top: '45%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2501, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <AvatarPopupContainer visible={avatarPopupVisible}>
              <AvatarPopImage 
                src={avatarPopImg} 
                alt="아바타 팝업" 
                visible={avatarPopupVisible}
                onLoad={() => setAvatarPopupImageLoaded(true)}
                onError={() => setAvatarPopupImageLoaded(true)} // 에러 시에도 로딩 완료로 처리
              />
            
            {/* 배후성 선택 옵션들 - 이미지 로딩 완료 후에만 표시 */}
            {avatarOptionsVisible && avatarPopupImageLoaded && backgroundOptions.map((option, index) => (
              <BackgroundOptionText
                key={index}
                $selected={selectedBackground === option || (option === "선택하지 않겠습니다." && selectedBackground === "없음")}
                $visible={avatarOptionsVisible}
                onClick={() => handleBackgroundSelect(option)}
                style={{
                  top: `${42 + (index * 7)}%`,
                  left: '19%',
                  transform: 'none',
                }}
              >
                {index + 1}. {option}
              </BackgroundOptionText>
            ))}

            {/* 배후성 선택 시 확인 버튼 - 이미지 로딩 완료 후에만 표시 */}
            {avatarOptionsVisible && avatarPopupImageLoaded && selectedBackground && (
              <div style={{ 
                position: 'absolute', 
                top: '80%', 
                left: '50%', 
                transform: 'translateX(-50%)',
                zIndex: 2502
              }}>
                <ConfirmBackgroundButton
                  src={contractConfirmBtnImg}
                  alt="확인"
                  onClick={handleBackgroundConfirm}
                />
              </div>
            )}
          </AvatarPopupContainer>
        </div>
      )}

      {/* 아바타 선택 완료 팝업 */}
      {showAvatarSelectedPopup && (
        <BlurOverlay visible={true} style={{ zIndex: 2500 }} />
      )}
      {showAvatarSelectedPopup && (
        <div style={{ position: 'fixed', top: '45%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2501, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <AvatarSelectedImage 
            src={avatarSelectedImg} 
            alt="아바타 선택 완료" 
            visible={showAvatarSelectedPopup}
            onLoad={() => setAvatarSelectedImageLoaded(true)}
            onError={() => setAvatarSelectedImageLoaded(true)} // 에러 시에도 로딩 완료로 처리
          />
        </div>
      )}

      {/* 등록 성공 팝업 */}
      {showSuccessPopup && (
        <BlurOverlay visible={true} style={{ zIndex: 3000 }} onClick={handleSuccessPopupClose} />
      )}
      {showSuccessPopup && (
        <div
          style={{ position: 'fixed', top: '45%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 3001, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          onClick={handleSuccessPopupClose}
        >
          {/* 기억해주세요 이미지 */}
          <img
            src={rememberImg}
            alt="기억해주세요"
            style={{
              width: '75dvw',
              height: 'auto',
              display: 'block'
            }}
          />
          <BluePopup isClosing={successPopupClosing}>
            <span style={{ fontSize: '1.3rem', display: 'block', marginTop: '0.2em' }}>[당신의</span>
            <div style={{height: '0.1rem'}} />
            <span style={{ fontSize: '1.3rem', display: 'block', marginBottom: '0.5em' }}>
              화신번호는 <span style={{ color: '#4FFFFF', fontWeight: 700 }}>{avatarNumber}</span> 입니다.]
            </span>
            <div style={{height: '0.2rem'}} />
            <span style={{ fontSize: '1.1rem', display: 'block', marginTop: '0.2em' }}>꼭 기억해주세요!</span>
          </BluePopup>
          <div style={{ width: '45vw', maxWidth: 320, height: 'auto', minHeight: '40px', marginTop: '-2.5dvw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img
              src={touchTxtImg}
              alt="터치 안내"
              style={{
                width: '45vw',
                maxWidth: 320,
                opacity: showSuccessImage ? 1 : 0,
                transition: 'opacity 0.4s',
                pointerEvents: 'none',
                userSelect: 'none',
                display: 'block'
              }}
            />
          </div>
        </div>
      )}
      
      {/* Firebase 에러 팝업 */}
      <FirebaseErrorPopup
        isVisible={errorState.isError}
        onClose={hideError}
        message={errorState.errorMessage}
      />
    </FadeInBackground>
  );
};

export default withUrlValidation(RegisterPage, {
  requireValidation: true,
  showCountdown: true
}); 